<template>
    <v-dialog v-model="dialogConfirm" persistent max-width="340">
        <v-card>
            <v-card-title class="text-h6">
                Mensaje de confirmación
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="text-center pt-4">
                {{ mensajeDialogData }}
            </v-card-text>
            <!-- ¿ Estas seguro de ejecutar esta acción ? -->
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" text @click="closeDialog(true)">
                    Aceptar
                </v-btn>
                <v-btn color="red darken-1" text @click="closeDialog(false)">
                    Cancelar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'confirmMensaje',
    props: {
        dialogConfirm: {
            type: Boolean,
            default: false
        },
        mensajeDialogData: {
            type: String,
            default: ""
        }
    },
    components: {},
    data() {
        return {
            dialog: false
        }
    },
    methods: {
        closeDialog(flag) {

            this.$emit('open-dialog', flag);

            if (flag) {
                this.$emit('update-dialog', true);
            }

        }
    }
    // watch:{
    //     dialogConfirm: function(e) {
    //         console.log(e)
    //       this.dialog=e;
    //     }
    // }
}
</script>

<style>



</style>